import { reducer as apiv3 } from "data/reducers/apiv3";
import { localeReducer as locale } from "data/reducers/locale";
import { reducer as currentUser } from "lib/api/currentUser";
import { reducer as routes } from "lib/api/experiences/routes";
import { reducer as search } from "lib/api/search";
import { combineReducers } from "redux";

export const rootReducer = combineReducers({
  apiv3,
  routes,
  // needed by LoadExisting
  search,
  currentUser,
  locale,
});
